module.exports = __webpack_public_path__ + "img/creme_brulee_raa_varm.c0c4348c.jpg";